import {
    Button,
    Icon,
    Link, SpaceBetween
} from "@cloudscape-design/components";
import {formatBytes, formatDate} from "../../utils/formatting";

export const TEXTS = {loadingText: "Retrieving files...", emptyTitle: 'No files', emptyMessage: 'This path does not contain any file.'}


function formatNameColumn(item, onFolderExpanded, onFileSelected) {
    const isFolder = item.Type === 'Folder'
    const iconName = isFolder? 'folder' : 'file';

    return (
        <SpaceBetween direction={'horizontal'} size={'xs'}>
            <Icon name={iconName} />

            {isFolder? <Link href={item.Name} onFollow={onFolderExpanded}>{item.Name}</Link> :
                <Button variant={'inline-link'} onClick={(event) => onFileSelected(item)}>{item.Name}</Button>
            }
        </SpaceBetween>
    )
}


export const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'Name',
        key: 'Name',
        groupValuesLabel: 'Names',
        operators: [':', '!:', '=', '!='],
    }
];


export function createColumnDefinitions(onFolderExpanded, onFileSelected) {
    const rawColumns = [
        {
            id: 'Name',
            sortingField: 'Name',
            header: 'Name',
            cell: item => formatNameColumn(item, onFolderExpanded, onFileSelected),
            width: 300,
        },
        {
            id: 'Type',
            sortingField: 'Type',
            header: 'Type',
            cell: item => item.Type,
            width: 150
        },
        {
            id: 'LastModified',
            sortingField: 'LastModified',
            header: 'Last modified',
            cell: item => item.Type === 'Folder'? '-' : formatDate(item.LastModified),
            width: 300
        },
        {
            id: 'Size',
            sortingField: 'Size',
            header: 'Size',
            cell: item => item.Type === 'Folder'? '-' : formatBytes(item.SizeBytes),
            width: 150
        }
    ];

    return rawColumns.map(column => ({...column}));
}